import { getDetailGrammar } from "@/api/Grammar.api";
const mixin = {
    store: ["detailsGrammar"],
    data() {
        return {
            loadingDetailGrammar: false,
            keyDetailGrammar: 0,
        };
    },
    methods: {
        async handleGetDetailGrammar() {
            this.keyDetailGrammar++;
            let params = {
                keyword: "",
                section: this.$route.params.section ? this.$route.params.section : "",
                id: this.$route.params.grammar,
            };
            this.loadingDetailGrammar = true;
            await getDetailGrammar(params)
                .then((data) => {
                    console.log("data.result: ", data.result);
                    this.detailsGrammar = data.result;
                    this.vocabularyGrammar = !data.result.vocabulary ? [] : data.result.vocabulary
                    if (this.detailsGrammar.data) {
                        this.detailsGrammar.data.forEach((item) => {
                            if (item.type == "image" && item.file) {
                                item.file.fileUrl = `${item.image_url}`;
                                delete item.file.file;
                                delete item.file.formData;
                            }
                            if (item.key == "ExampleSentence" && item.file) {
                                item.file.fileUrl = `${item.audio_url}`;
                                delete item.file.file;
                                delete item.file.formData;
                            }
                        });
                        this.fieldsGrammar = this.detailsGrammar.data;
                    }
                    this.loadingDetailGrammar = false;
                })
                .catch((error) => {
                    this.loadingDetailGrammar = false;
                    console.log(error);
                });
        },
        async resetList() {
            await this.handleGetDetailGrammar();
        },
    },
};

export default mixin;